import { IRoleAccessRuleLang } from '../../../types/lang'

export const roleAccessRuleLang: IRoleAccessRuleLang = {
	role_access_rule: {
		title_label_access: 'Access_ru',

		any_name: 'Any access_ru',
		any_tooltip: 'Allows maximal access to system._ru',
		api_health_check_name: 'Api Health Check_ru',
		api_health_check_tooltip: 'Allows api health check._ru',
		api_postback_send_name: 'Postback Send_ru',
		api_postback_send_tooltip: 'Allows <icon /> api send postback._ru',

		auth_login_name: 'System Login access_ru',
		auth_login_tooltip: 'Allows login to system._ru',
		auth_profile_name: 'System Profile access_ru',
		auth_profile_tooltip: 'Allows fetching profile data in system.<br />Used over all in system._ru',

		common_country_any_name: 'Countries any access_ru',
		common_country_any_tooltip: 'Allows all actions on countries in system._ru',
		common_country_list_name: 'Countries list access_ru',
		common_country_list_tooltip: 'Allows get countries list in system.<br />Used in {{menuTitle}} filters._ru',
		common_country_read_name: 'Countries read access_ru',
		common_country_read_tooltip: 'Allows get country by code in system.<br />Not used._ru',

		common_language_any_name: 'Languages any access_ru',
		common_language_any_tooltip: 'Allows all actions on language\'s in system._ru',
		common_language_list_name: 'Languages list access_ru',
		common_language_list_tooltip: 'Allows get language\'s list in system.<br />Not used._ru',
		common_language_read_name: 'Languages read access_ru',
		common_language_read_tooltip: 'Allows get language by code in system.<br />Not used._ru',

		common_time_zone_any_name: 'Time zones any access_ru',
		common_time_zone_any_tooltip: 'Allows all actions on time zone\'s in system._ru',
		common_time_zone_list_name: 'Time zones list access_ru',
		common_time_zone_list_tooltip: 'Allows get time zone\'s list in system.<br />Not used._ru',
		common_time_zone_read_name: 'Time zones read access_ru',
		common_time_zone_read_tooltip: 'Allows get time zone by code in system.<br />Not used._ru',

		role_any_name: 'Role any_ru',
		role_any_tooltip: 'Allows all actions on <icon /> role\'s in system.<br />Used in {{menuTitle}}._ru',
		role_list_name: 'Role list_ru',
		role_list_tooltip: 'Allows get list of <icon /> role\'s.<br />Used in {{menuTitle}}._ru',
		role_read_name: 'Role read_ru',
		role_read_tooltip: 'Allows get single <icon /> role.<br />Used in {{menuTitle}}._ru',
		role_create_name: 'Role create_ru',
		role_create_tooltip: 'Allows create new <icon /> role.<br />Used in {{menuTitle}}._ru',
		role_modify_name: 'Role modify_ru',
		role_modify_tooltip: 'Allows modify <icon /> role.<br />Used in {{menuTitle}}._ru',
		role_remove_name: 'Role remove_ru',
		role_remove_tooltip: 'Allows remove <icon /> role.<br />Used in {{menuTitle}}._ru',

		account_any_name: 'Account any_ru',
		account_any_tooltip: 'Allows all actions on <icon /> account\'s in system.<br />Used in {{menuTitle}}._ru',
		account_list_name: 'Account list_ru',
		account_list_tooltip: 'Allows get list of <icon /> account\'s.<br />Used in {{menuTitle}}._ru',
		account_is_fired_list_name: 'Account fired list_ru',
		account_is_fired_list_tooltip: 'Allows get list of <icon /> fired account\'s.<br />Used in {{menuTitle}}._ru',
		account_read_name: 'Account read_ru',
		account_read_tooltip: 'Allows get single <icon /> account.<br />Used in {{menuTitle}}._ru',
		account_create_name: 'Account create_ru',
		account_create_tooltip: 'Allows create new <icon /> account.<br />Used in {{menuTitle}}._ru',
		account_modify_name: 'Account modify_ru',
		account_modify_tooltip: 'Allows modify <icon /> account.<br />Used in {{menuTitle}}._ru',
		account_remove_name: 'Account remove_ru',
		account_remove_tooltip: 'Allows remove <icon /> account.<br />Used in {{menuTitle}}._ru',
		account_resurrect_name: 'Account resurrect_ru',
		account_resurrect_tooltip: 'Allows resurrect removed <icon /> account.<br />Used in {{menuTitle}}._ru',

		account_buyer_any_name: 'Account buyer any_ru',
		account_buyer_any_tooltip: 'Allows all actions on buyer\'s in system.<br />Used in {{menuTitle_1}} and {{menuTitle_2}}._ru',
		account_buyer_self_name: 'Account buyer self only_ru',
		account_buyer_self_tooltip: 'Allows get single buyer in list only.<br />Used in {{menuTitle_1}} and {{menuTitle_2}}._ru',
		account_buyer_list_name: 'Account buyer list_ru',
		account_buyer_list_tooltip: 'Allows get list of buyer\'s.<br />Used in {{menuTitle_1}} and {{menuTitle_2}}._ru',

		account_team_any_name: 'Account team any_ru',
		account_team_any_tooltip: 'Allows all actions on team\'s in system.<br />Used in {{menuTitle}}._ru',
		account_team_self_name: 'Account team self only_ru',
		account_team_self_tooltip: 'Allows get single team in list only.<br />Used in {{menuTitle}}_ru',
		account_team_list_name: 'Account team list_ru',
		account_team_list_tooltip: 'Allows get list of team\'s.<br />Used in {{menuTitle}}_ru',

		affiliate_any_name: 'Affiliate any_ru',
		affiliate_any_tooltip: 'Allows all actions on <icon /> affiliate\'s in system.<br />Used in {{menuTitle}}._ru',
		affiliate_list_name: 'Affiliate list_ru',
		affiliate_list_tooltip: 'Allows get list of <icon /> affiliate\'s.<br />Used in {{menuTitle}}._ru',
		affiliate_read_name: 'Affiliate read_ru',
		affiliate_read_tooltip: 'Allows get single <icon /> affiliate.<br />Used in {{menuTitle}}._ru',
		affiliate_create_name: 'Affiliate create_ru',
		affiliate_create_tooltip: 'Allows create new <icon /> affiliate.<br />Used in {{menuTitle}}._ru',
		affiliate_modify_name: 'Affiliate modify_ru',
		affiliate_modify_tooltip: 'Allows modify <icon /> affiliate.<br />Used in {{menuTitle}}._ru',
		affiliate_remove_name: 'Affiliate remove_ru',
		affiliate_remove_tooltip: 'Allows remove <icon /> affiliate.<br />Used in {{menuTitle}}._ru',

		offer_scope_any_name: 'Offer scope any_ru',
		offer_scope_any_tooltip: 'Allows all actions on <icon /> offer scope\'s in system.<br />Used in {{menuTitle}}._ru',
		offer_scope_list_name: 'Offer scope list_ru',
		offer_scope_list_tooltip: 'Allows get list of <icon /> offer scope\'s.<br />Used in {{menuTitle}}._ru',
		offer_scope_read_name: 'Offer scope read_ru',
		offer_scope_read_tooltip: 'Allows get single <icon /> offer scope.<br />Used in {{menuTitle}}._ru',
		offer_scope_create_name: 'Offer scope create_ru',
		offer_scope_create_tooltip: 'Allows create new <icon /> offer scope.<br />Used in {{menuTitle}}._ru',
		offer_scope_modify_name: 'Offer scope modify_ru',
		offer_scope_modify_tooltip: 'Allows modify <icon /> offer scope.<br />Used in {{menuTitle}}._ru',
		offer_scope_remove_name: 'Offer scope remove_ru',
		offer_scope_remove_tooltip: 'Allows remove <icon /> offer scope.<br />Used in {{menuTitle}}._ru',

		offer_any_name: 'Offer any_ru',
		offer_any_tooltip: 'Allows all actions on <icon /> offer\'s in system.<br />Used in {{menuTitle}}._ru',
		offer_any_group_name: 'Offer any group_ru',
		offer_any_group_tooltip: 'Allows get list of <icon /> offer\'s in any group.<br />Used in {{menuTitle}}._ru',
		offer_list_name: 'Offer list_ru',
		offer_list_tooltip: 'Allows get list of <icon /> offer\'s.<br />Used in {{menuTitle}}._ru',
		offer_read_name: 'Offer read_ru',
		offer_read_tooltip: 'Allows get single <icon /> offer.<br />Used in {{menuTitle}}._ru',
		offer_create_name: 'Offer create_ru',
		offer_create_tooltip: 'Allows create new <icon /> offer.<br />Used in {{menuTitle}}._ru',
		offer_modify_name: 'Offer modify_ru',
		offer_modify_tooltip: 'Allows modify <icon /> offer.<br />Used in {{menuTitle}}._ru',
		offer_remove_name: 'Offer remove_ru',
		offer_remove_tooltip: 'Allows remove <icon /> offer.<br />Used in {{menuTitle}}._ru',
		offer_resurrect_name: 'Offer resurrect_ru',
		offer_resurrect_tooltip: 'Allows resurrect removed <icon /> offer.<br />Used in {{menuTitle}}._ru',
		offer_bind_name: 'Offer bind_ru',
		offer_bind_tooltip: 'Allows binding <icon /> offer to scope.<br />Used in {{menuTitle}}._ru',
		offer_unbind_name: 'Offer unbind_ru',
		offer_unbind_tooltip: 'Allows unbind <icon /> offer from scope.<br />Used in {{menuTitle}}._ru',

		offer_spend_any_name: 'Offer Spend any_ru',
		offer_spend_any_tooltip: 'Allows all actions on <icon /> offer spend\'s in system.<br />Used in {{menuTitle}}._ru',
		offer_spend_any_account_name: 'Offer Spend any account_ru',
		offer_spend_any_account_tooltip: 'Allows edit on <icon /> offer spend\'s by any account.<br />Used in {{menuTitle}} Create / Edit._ru',
		offer_spend_any_day_name: 'Offer Spend any day_ru',
		offer_spend_any_day_tooltip: 'Allows edit on <icon /> offer spend\'s at any date.<br />Used in {{menuTitle}} Create / Edit._ru',
		offer_spend_any_group_name: 'Offer Spend any group_ru',
		offer_spend_any_group_tooltip: 'Allows edit on <icon /> offer spend\'s by offer in any group.<br />Used in {{menuTitle}} Create / Edit._ru',
		offer_spend_list_name: 'Offer Spend list_ru',
		offer_spend_list_tooltip: 'Allows get list of <icon /> offer spend\'s.<br />Used in {{menuTitle}}._ru',
		offer_spend_read_name: 'Offer Spend read_ru',
		offer_spend_read_tooltip: 'Allows get single <icon /> offer spend.<br />Used in {{menuTitle}}._ru',
		offer_spend_create_name: 'Offer Spend create_ru',
		offer_spend_create_tooltip: 'Allows create new <icon /> offer spend.<br />Used in {{menuTitle}}._ru',
		offer_spend_modify_name: 'Offer Spend modify_ru',
		offer_spend_modify_tooltip: 'Allows modify <icon /> offer spend.<br />Used in {{menuTitle}}._ru',
		offer_spend_remove_name: 'Offer Spend remove_ru',
		offer_spend_remove_tooltip: 'Allows remove <icon /> offer spend.<br />Used in {{menuTitle}}._ru',

		offer_spend_by_any_name: 'Offer Spend by any_ru',
		offer_spend_by_any_tooltip: 'Allows all actions on <icon /> offer spend report\'s in system.<br />Used in {{menuTitle}}._ru',
		offer_spend_by_account_list_name: 'Offer Spend by account list_ru',
		offer_spend_by_account_list_tooltip: 'Allows get report <icon /> offer spend by account._ru',
		offer_spend_by_offer_list_name: 'Offer Spend by offer list_ru',
		offer_spend_by_offer_list_tooltip: 'Allows get report <icon /> offer spend by offer._ru',
		offer_spend_by_offer_scope_list_name: 'Offer Spend by scope list_ru',
		offer_spend_by_offer_scope_list_tooltip: 'Allows get report <icon /> offer spend by offer scope._ru',

		revenue_any_name: 'Revenue any_ru',
		revenue_any_tooltip: 'Allows all actions on <icon /> Revenue\'s in system.<br />Used in {{menuTitle}}._ru',
		revenue_list_name: 'Revenue list_ru',
		revenue_list_tooltip: 'Allows get list of <icon /> revenue\'s.<br />Used in {{menuTitle}}._ru',
		revenue_read_name: 'Revenue read_ru',
		revenue_read_tooltip: 'Allows get single <icon /> revenue.<br />Used in {{menuTitle}}._ru',
		revenue_create_name: 'Revenue create_ru',
		revenue_create_tooltip: 'Allows create new <icon /> revenue.<br />Used in {{menuTitle}}._ru',
		revenue_modify_name: 'Revenue modify_ru',
		revenue_modify_tooltip: 'Allows modify <icon /> revenue.<br />Used in {{menuTitle}}._ru',
		revenue_remove_name: 'Revenue remove_ru',
		revenue_remove_tooltip: 'Allows remove <icon /> revenue.<br />Used in {{menuTitle}}._ru',

		revenue_agency_any_name: 'Revenue Agency any_ru',
		revenue_agency_any_tooltip: 'Allows all actions on <icon /> revenue agency\'s in system.<br />Used in {{menuTitle}}._ru',
		revenue_agency_list_name: 'Revenue Agency list_ru',
		revenue_agency_list_tooltip: 'Allows get list of <icon /> revenue agency\'s.<br />Used in {{menuTitle}}._ru',
		revenue_agency_read_name: 'Revenue Agency read_ru',
		revenue_agency_read_tooltip: 'Allows get single <icon /> revenue agency.<br />Used in {{menuTitle}}._ru',
		revenue_agency_create_name: 'Revenue Agency create_ru',
		revenue_agency_create_tooltip: 'Allows create new <icon /> revenue agency.<br />Used in {{menuTitle}}._ru',
		revenue_agency_modify_name: 'Revenue Agency modify_ru',
		revenue_agency_modify_tooltip: 'Allows modify <icon /> revenue agency.<br />Used in {{menuTitle}}._ru',
		revenue_agency_remove_name: 'Revenue Agency remove_ru',
		revenue_agency_remove_tooltip: 'Allows remove <icon /> revenue agency.<br />Used in {{menuTitle}}._ru',

		revenue_spend_any_name: 'Revenue Spend any_ru',
		revenue_spend_any_tooltip: 'Allows all actions on <icon /> revenue spend\'s in system.<br />Used in {{menuTitle}}._ru',
		revenue_spend_list_name: 'Revenue Spend list_ru',
		revenue_spend_list_tooltip: 'Allows get list of <icon /> revenue spend\'s.<br />Used in {{menuTitle}}._ru',
		revenue_spend_read_name: 'Revenue Spend read_ru',
		revenue_spend_read_tooltip: 'Allows get single <icon /> revenue spend.<br />Used in {{menuTitle}}._ru',
		revenue_spend_create_name: 'Revenue Spend create_ru',
		revenue_spend_create_tooltip: 'Allows create new <icon /> revenue spend.<br />Used in {{menuTitle}}._ru',
		revenue_spend_modify_name: 'Revenue Spend modify_ru',
		revenue_spend_modify_tooltip: 'Allows modify <icon /> revenue spend.<br />Used in {{menuTitle}}._ru',
		revenue_spend_remove_name: 'Revenue Spend remove_ru',
		revenue_spend_remove_tooltip: 'Allows remove <icon /> revenue spend.<br />Used in {{menuTitle}}._ru',

		revenue_spend_by_any_name: 'Revenue Spend by any_ru',
		revenue_spend_by_any_tooltip: 'Allows all actions on <icon /> revenue spend report\'s in system.<br />Used in {{menuTitle_1}} or {{menuTitle_2}}._ru',
		revenue_spend_by_account_list_name: 'Revenue Spend by account list_ru',
		revenue_spend_by_account_list_tooltip: 'Allows get report <icon /> revenue spend by account._ru',
		revenue_spend_by_accounts_list_name: 'Revenue Spend by accounts list_ru',
		revenue_spend_by_accounts_list_tooltip: 'Allows get report <icon /> revenue spend by accounts._ru',
		revenue_spend_by_team_list_name: 'Revenue Spend by team list_ru',
		revenue_spend_by_team_list_tooltip: 'Allows get report <icon /> revenue spend by team._ru',
		revenue_spend_by_teams_list_name: 'Revenue Spend by teams list_ru',
		revenue_spend_by_teams_list_tooltip: 'Allows get report <icon /> revenue spend by teams._ru',

		debug_any_name: 'Debug any_ru',
		debug_any_tooltip: 'Allows view all debug._ru',
		debug_cron_runner_name: 'Debug cron runner access_ru',
		debug_cron_runner_tooltip: 'Allows cron runner via URI._ru',
		debug_draft_name: 'Draft access enabled_ru',
		debug_draft_tooltip: 'Allows view draft\'s._ru',
		debug_message_name: 'Debug message enabled_ru',
		debug_message_tooltip: 'Allows view debug message and trace on error\'s in console._ru',

		job_any_name: 'Job any_ru',
		job_any_tooltip: 'Allows all actions on <icon /> job\'s in system.<br />Used in {{menuTitle}}._ru',
		job_list_name: 'Job list_ru',
		job_list_tooltip: 'Allows get list of <icon /> job\'s.<br />Used in {{menuTitle}}._ru',
		job_read_name: 'Job read_ru',
		job_read_tooltip: 'Allows get single <icon /> job.<br />Used in {{menuTitle}}._ru',
		job_create_name: 'Job create_ru',
		job_create_tooltip: 'Allows create new <icon /> job.<br />Used in {{menuTitle}}._ru',
		job_modify_name: 'Job modify_ru',
		job_modify_tooltip: 'Allows modify <icon /> job.<br />Used in {{menuTitle}}._ru',
		job_remove_name: 'Job remove_ru',
		job_remove_tooltip: 'Allows remove <icon /> job.<br />Used in {{menuTitle}}._ru',

		project_any_name: 'Project any_ru',
		project_any_tooltip: 'Allows all actions on <icon /> project\'s in system.<br />Used in {{menuTitle}}._ru',
		project_list_name: 'Project list_ru',
		project_list_tooltip: 'Allows get list of <icon /> project\'s.<br />Used in {{menuTitle}}._ru',
		project_read_name: 'Project read_ru',
		project_read_tooltip: 'Allows get single <icon /> project.<br />Used in {{menuTitle}}._ru',
		project_create_name: 'Project create_ru',
		project_create_tooltip: 'Allows create new <icon /> project.<br />Used in {{menuTitle}}._ru',
		project_modify_name: 'Project modify_ru',
		project_modify_tooltip: 'Allows modify <icon /> project.<br />Used in {{menuTitle}}._ru',
		project_remove_name: 'Project remove_ru',
		project_remove_tooltip: 'Allows remove <icon /> project.<br />Used in {{menuTitle}}._ru',
	}
}